export default __webpack_public_path__ + "static/media/Bajaj5.a8a9d3d2.jpg";